import { useEffect, useRef } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { BackgroundVideo } from 'core/flow/entities';
import { PosterStyled, VideoStyled } from './styled';

const sharedVideoProps = {
  muted: true,
  playsInline: true,
  disablePictureInPicture: true,
};

const ignorePlaybackRejection = () => {};

type LoopingVideoProps = {
  isPaused?: boolean;
} & BackgroundVideo;

export const LoopingVideo = ({ src, poster, isPaused = false }: LoopingVideoProps) => {
  const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;

    if (!video) {
      return;
    }

    if (isPaused) {
      video.pause();
      return;
    }

    const resume = () => {
      video.play().catch(ignorePlaybackRejection);
    };

    resume();
    video.addEventListener('pause', resume);

    return () => {
      video.removeEventListener('pause', resume);
    };
  }, [isPaused]);

  return (
    <>
      <PosterStyled src={poster} alt="poster" fill priority />
      {!prefersReducedMotion && <VideoStyled {...sharedVideoProps} ref={videoRef} src={src} loop />}
    </>
  );
};
